import type { BrandingStripProps } from './BrandingStrip.typed';
import * as Styled from './BrandingStrip.styled';

const BrandingStrip = (props: BrandingStripProps) => {
  const { name, logo, isGrid } = props;
  return (
    <Styled.Container isGrid={isGrid}>
      {logo && <Styled.Logo src={logo} alt={name} />}
      <Styled.Title
        size="M16"
        color="GREY_DARKER"
        weight={'bold'}
        forwardedAs="div"
      >
        {name}
      </Styled.Title>
    </Styled.Container>
  );
};

export { BrandingStrip };
